import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextH2Props {
    children: ReactNode
    className?: string
}

const TextH2 = ({ children, className }: TextH2Props) => {
    return <h2 className={[css.h2, className].filter(Boolean).join(' ')}>{children}</h2>
}

export default TextH2
